module.exports = __webpack_public_path__ + "static/img/btn_99_1.50926de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/btn_99_1.png
// module id = InHN
// module chunks = 0